import { http } from "../framework/api";
import config from "../config";

export const validateSessionIdentity = (firstName, lastName, dateOfBirth) => {
  const url = `${config.API_ROOT_URL}/sessions/validate-identity`;
  return http("POST", url, { firstName, lastName, dateOfBirth });
};

// Fetches the current Kipu-link status straight from the server. The value
// cached at login (sessionStorage/Redux) goes stale whenever a "stay logged
// in" session outlives its original tab (new tab, browser restart), so the
// identity modal must not rely on it to decide whether to show the DOB field.
export const getKipuStatus = () => {
  const url = `${config.API_ROOT_URL}/accounts/kipu-status`;
  return http("GET", url);
};
